Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
stickerSize = require 'data/sticker-size'
stickerClip = require 'lib/util/sticker-clip'

module.exports = class StickerView extends View
  className: 'sticker'

  showEditControls: ->
    false

  render: ->
    data = @model.toJSON()
    data.url =
      Util.smallestPreviewBiggerThan(data.imageScaled, stickerSize)?.url ?
      data.imageUrl
    data.showEditControls = @showEditControls()

    @$el
    .html(
      templates.fill(
        'sticker_on_card',
        data
      )
    )
    .css({
      left: "#{ stickerClip(data.left) }%"
      top:  "#{ stickerClip(data.top) }%"
    })

    @



// WEBPACK FOOTER //
// ./app/scripts/views/stickers/sticker-view.coffee